import React, { PropsWithChildren } from 'react';
import type { NextRouter } from 'next/router';
import { RouterContext } from 'next/dist/shared/lib/router-context.shared-runtime';

type TestRouterProviderProps = PropsWithChildren<{
  router?: Partial<NextRouter>;
}>;

export function TestRouterProvider({ children, router = {} }: TestRouterProviderProps): JSX.Element {
  const {
    route = '',
    pathname = '',
    query = {},
    asPath = '',
    push = async () => true,
    replace = async () => true,
    reload = () => null,
    back = () => null,
    prefetch = async () => undefined,
    beforePopState = () => null,
    isFallback = false,
    isReady = true,
    events = {
      on: () => null,
      off: () => null,
      emit: () => null,
    },
  } = router;

  // This test utility intentionally supplies only the router fields its consumers use, exactly
  // as the original JSX did. RouterContext requires the complete NextRouter production shape;
  // asserting at this one test-double boundary preserves the existing sparse runtime object
  // without fabricating locale/basePath fields tests never provided or observed.
  const routerValue = {
    route,
    pathname,
    query,
    asPath,
    push,
    replace,
    reload,
    back,
    prefetch,
    beforePopState,
    isFallback,
    isReady,
    events,
  } as NextRouter;

  return <RouterContext.Provider value={routerValue}>{children}</RouterContext.Provider>;
}
